/**
 * Enum for virus scan statuses
 */
export enum VirusScanStatus {
  CLEAN = 'CLEAN',
  INFECTED = 'INFECTED',
  SCANNING = 'SCANNING',
  ERROR = 'ERROR',
  NOT_SCANNED = 'NOT_SCANNED',
}

/**
 * Interface for tracking virus scan results
 */
export interface VirusScanState {
  status: VirusScanStatus;
  message?: string;
  timestamp?: string;
  scanId?: string;
}
